import * as React from 'react'
import { Link } from 'react-router'
import { API, PaymentFilter, InvoiceStatus, ICategoryContract } from '@getgreenline/homi-shared'
import { LoadingAnimation } from '../../../components/LoadingAnimation'
import { Routes } from '../../../constants/Routes'
import { productApi } from '@getgreenline/products'
import { BlazeButton } from '../../../components/CustomButtons/BlazeButton'

interface Props {
  companyId: number
  completeOnboarding: () => void
}

interface State {
  categories?: ICategoryContract[]
  totalProducts?: number
  totalCompletePurchaseOrders?: number
  totalPayments?: number
}

export class Onboarding extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.loadOnboarding()
  }

  async loadOnboarding() {
    const { companyId } = this.props
    const categories = await API.getCategories(companyId)
    const { total: productsTotal } = await productApi.getProducts(companyId, { limit: 10 })
    const { total: purchaseOrdersTotal } = await API.getInvoices(companyId, {
      offset: 0,
      limit: 1,
      status: 'completed' as InvoiceStatus,
    })
    const { total: paymentsTotal } = await API.getPayments(
      companyId,
      new PaymentFilter(companyId, 1, 0),
    )
    this.setState({
      categories: categories,
      totalProducts: productsTotal,
      totalCompletePurchaseOrders: purchaseOrdersTotal,
      totalPayments: paymentsTotal,
    })
  }

  getCheckbox(status?: boolean) {
    let color = ''
    if (status === true) {
      color = 'text-success'
    }
    if (status === false) {
      color = 'text-danger'
    }

    return <span className={'fa fa-2x fa-check-circle ' + color} />
  }

  render() {
    const { companyId } = this.props
    const { categories, totalProducts, totalCompletePurchaseOrders, totalPayments } = this.state
    const isLoading =
      !categories ||
      totalProducts === undefined ||
      totalCompletePurchaseOrders === undefined ||
      totalPayments === undefined

    if (isLoading) {
      return (
        <div>
          <LoadingAnimation />
        </div>
      )
    }

    const hasComplianceCategories =
      categories && categories.filter((c) => c.complianceCategoryId).length > 0
    const has10Products = !!totalProducts && totalProducts >= 10
    const hasPurchaseOrder = !!totalCompletePurchaseOrders && totalCompletePurchaseOrders > 0
    const hasPayment = !!totalPayments && totalPayments >= 1
    const isComplete = hasComplianceCategories && has10Products && hasPurchaseOrder && hasPayment

    return (
      <div>
        <h5 className='text-muted' style={{ flexGrow: 1 }}>
          Get started
        </h5>
        <table className='table mb-2'>
          <tbody>
            <tr>
              <td>
                <h5 className='text-muted'>Add cannabis categories</h5>
                <div className='text-muted font-weight-bold'>
                  {categories
                    ? categories.filter((c) => c.complianceCategoryId).length + ' cannabis'
                    : '-'}
                  , {(categories || []).length} total
                </div>
                <div className='text-muted'>
                  <Link to={Routes.DASHBOARD_PRODUCTS_CATEGORIES(companyId)}>Add categories</Link>
                </div>
              </td>
              <td className='text-right'>{this.getCheckbox(hasComplianceCategories)}</td>
            </tr>
            <tr>
              <td>
                <h5 className='text-muted'>Add 10 products</h5>
                <div className='text-mute font-weight-bold'>{totalProducts} products</div>
                <div className='text-muted'>
                  <Link to={Routes.DASHBOARD_PRODUCTS_LISTING(companyId)}>Add products</Link>
                </div>
              </td>
              <td className='text-right'>{this.getCheckbox(has10Products)}</td>
            </tr>
            <tr>
              <td>
                <h5 className='text-muted'>Complete 1 purchase order</h5>
                <div className='text-muted font-weight-bold'>
                  {totalCompletePurchaseOrders} completed purchase orders
                </div>
                <div className='text-muted'>
                  <Link to={Routes.DASHBOARD_INVOICES(companyId)}>Add purchase orders</Link>
                </div>
              </td>
              <td className='text-right'>{this.getCheckbox(hasPurchaseOrder)}</td>
            </tr>
            <tr>
              <td>
                <h5 className='text-muted'>Make a sale</h5>
                <div className='text-muted font-weight-bold'>{totalPayments} completed sales</div>
                <div className='text-muted'>Log into your POS to get started.</div>
              </td>
              <td className='text-right'>{this.getCheckbox(hasPayment)}</td>
            </tr>
          </tbody>
        </table>
        <div>
          <BlazeButton
            buttonProps={{
              className: 'w-100',
              type: 'primary',
              size: 'large',
              onClick: () => {
                if (isComplete) {
                  this.props.completeOnboarding()
                } else {
                  if (
                    window.confirm(
                      'Are you sure? Your onboarding steps are not yet complete. This can be turned on again in your settings.',
                    )
                  ) {
                    this.props.completeOnboarding()
                  }
                }
              },
            }}
            titleProps={{
              title: 'Complete onboarding',
            }}
          />
        </div>
      </div>
    )
  }
}
